import { render, staticRenderFns } from "./3_images.vue?vue&type=template&id=47e067de&"
import script from "./3_images.vue?vue&type=script&lang=js&"
export * from "./3_images.vue?vue&type=script&lang=js&"
import style0 from "./3_images.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports